import React, { useRef } from "react";
import cn from "classnames";
import { SVG, CartContent, CartUpsellWindow } from "~components";
import { useAppContext, useCartContext, useTrapFocus } from "~hooks";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Global cart component
 *
 * @return {node}
 */

const Cart = () => {
  const { isCartOpen, setIsCartOpen } = useAppContext();
  const { cartItems, isCartUpsellWindowOpen } = useCartContext();

  const containerRef = useRef();
  const bypassTrapFocus = isCartUpsellWindowOpen;
  useTrapFocus(isCartOpen, containerRef, bypassTrapFocus); // If open, handle in that component instead

  const numberOfItems = cartItems?.length;
  const numberItemsText = `${numberOfItems || 0} Item${
    numberOfItems === 1 ? `` : `s`
  }`;

  return (
    <div
      className={cn(styles.container, { [styles.open]: isCartOpen })}
      ref={containerRef}
      aria-hidden={!isCartOpen}
    >
      <div className={styles.content}>
        {/* Top bar */}
        <div className={styles.topBar}>
          <div className={styles.left}>
            <button
              type="button"
              aria-label="Close cart"
              className={styles.closeButton}
              onClick={() => setIsCartOpen(false)}
            >
              <SVG svg="x" />
            </button>
            <div className="b1">Your Cart</div>
          </div>
          <div className="b2">{numberItemsText}</div>
        </div>

        {/* Rest of the cart other than top bar */}
        <CartContent />

        {/* Slide up panel for when adding items from the cart */}
        <CartUpsellWindow />
      </div>
      {/* eslint-disable-next-line */}
      <div className={styles.gradient} onClick={() => setIsCartOpen(false)} />
    </div>
  );
};

export default Cart;
